import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "account-container"
};
const _hoisted_2 = {
  key: 0,
  class: "content-container"
};
const _hoisted_3 = {
  key: 1,
  class: "account-container"
};
const _hoisted_4 = {
  key: 0,
  class: "content-container"
};
const _hoisted_5 = {
  class: "card-container"
};
const _hoisted_6 = {
  key: 1,
  class: "empty-content-container"
};
import { computed, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import router from "@/router";
import { inApostleType, isApostleType, isUserType } from '@/tools/utils';
import { isOpenDrawer } from "@/theme/drawerStyle";
import { pageStyle, sliderWidth } from "@/theme/sliderStyle";
import RoleManager from '@/components/Role/RoleManager.vue';
import AccountWorkbenches from '@/components/Account/AccountWorkbenches.vue';
import UserInfoBox from '@/components/Account/UserInfoBox.vue';
import RoleCard from "@/components/Role/RoleCard.vue";
import { Plus } from "@element-plus/icons-vue"; // computed

export default {
  __name: 'AccountPage',

  setup(__props) {
    const appInfo = computed(() => store.state.app_info);
    const user = computed(() => store.state.user);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const roleArray = computed(() => store.state.role_array ?? []);
    const selectedRole = computed(() => store.state.selected_role);
    const worldOutlook = computed(() => store.state.world_outlook || null);
    const ceremonies = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.ceremonies ?? null;
    }); // functions

    const getUser = (isManual = false) => {
      request('user/get_user_info/', {}, 'GET').then(response => {
        // console.log(JSON.stringify(response.data))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg
          });
          return;
        }

        store.commit('update_user', response.data);
        const user_type = response.data.user_type;

        if (isUserType(user_type)) {
          store.dispatch('get_roles');
        } else if (isApostleType(user_type)) {
          store.commit('update_world_outlook', response.data.apostle_wo);
        }

        if (isManual) {
          ElMessage.success('更新成功');
        }
      });
    };

    const logout = () => {
      store.commit('delete_user');
      store.commit('update_headers', null);
      store.commit('delete_all_role_info');
      store.commit('update_role_array', []);
      store.commit('update_selected_role', null);
      store.commit('update_stage', null);
      localStorage.removeItem('headers');
      sliderWidth.value = 0;
      isOpenDrawer.value = false;
      router.replace('/login');
    };

    const getAppInfo = () => {
      request('basic/app_info/', {}, 'GET').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.commit('update_app_info', response.data);
        loadCapabilityData();
      });
    };

    const loadCapabilityData = async () => {
      if (!appInfo.value) return;
      const capabilityInfo = appInfo.value?.capability_info;
      if (!capabilityInfo?.file) return;
      const url = capabilityInfo.file;
      const md5 = capabilityInfo.md5;
      const version = capabilityInfo.version;
      const fileName = `capability_configure_${version}.json`;
      const root = await navigator.storage.getDirectory();
      const folder = await root.getDirectoryHandle('downloads', {
        create: true
      });
      let fileHandle = null;

      try {
        fileHandle = await folder.getFileHandle(fileName);
        const localMD5 = await getStorageMD5(fileName); // console.log(`配置版本=${version} 本地文件MD5=${localMD5} 远端文件MD5=${md5}`)

        if (localMD5 !== md5) {
          fileHandle = await downloadFile(folder, url, fileName, md5);
        }
      } catch (e) {
        fileHandle = await downloadFile(folder, url, fileName, md5);
      }

      const file = await fileHandle.getFile();
      const text = await file.text();
      store.commit('update_capability_configure', JSON.parse(text));
    };

    const downloadFile = async (folder, url, fileName, md5) => {
      const fileHandle = await folder.getFileHandle(fileName, {
        create: true
      });

      for await (const entry of folder.values()) {
        if (entry.kind === 'file' && entry.name.startsWith('capability_configure_') && entry.name !== fileName) {
          await folder.removeEntry(entry.name);
        }
      }

      const resp = await fetch(url);
      const blob = await resp.blob();
      const writable = await fileHandle.createWritable();
      await writable.write(blob);
      await writable.close();
      await saveStorageMD5(fileName, md5);
      return fileHandle;
    };

    const getStorageMD5 = async fileName => {
      return new Promise(resolve => {
        const req = indexedDB.open('FileCacheDB', 1);

        req.onupgradeneeded = () => req.result.createObjectStore('files', {
          keyPath: 'name'
        });

        req.onsuccess = () => {
          const db = req.result;
          const tx = db.transaction('files', 'readonly');
          const getReq = tx.objectStore('files').get(fileName);

          getReq.onsuccess = () => resolve(getReq.result?.md5 || null);

          getReq.onerror = () => resolve(null);
        };

        req.onerror = () => resolve(null);
      });
    };

    const saveStorageMD5 = async (fileName, md5) => {
      return new Promise(resolve => {
        const req = indexedDB.open('FileCacheDB', 1);

        req.onupgradeneeded = () => req.result.createObjectStore('files', {
          keyPath: 'name'
        });

        req.onsuccess = () => {
          const db = req.result;
          const tx = db.transaction('files', 'readwrite');
          tx.objectStore('files').put({
            name: fileName,
            md5,
            updatedAt: Date.now()
          });

          tx.oncomplete = () => resolve();

          tx.onerror = () => resolve();
        };

        req.onerror = () => resolve();
      });
    };

    const getCeremonyData = () => {
      if (!worldOutlook.value) return;

      if (isUserType(userType.value) && !ceremonies.value) {
        let parameters = {
          'world_outlook_id': worldOutlook.value.id
        };
        request('ceremony/list/', parameters, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code !== 0) {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
            return;
          }

          store.commit('update_wo_info', {
            wo_id: worldOutlook.value.id,
            key: 'ceremonies',
            value: response.data
          });
        });
      }
    };

    const openEditMode = (roleId = null) => {
      router.push({
        name: 'roleGenerator',
        params: {
          roleId: roleId
        }
      });
    }; // const closeEditMode = () => {
    //   if (!selectedRole.value) {
    //     store.dispatch('get_roles')
    //   } else {
    //     store.commit('delete_role_info', {
    //       role_id: selectedRole.value,
    //       key: null,
    //     })
    //   }
    //   roleEditMode.value = false
    // }
    // lifecycle


    onMounted(() => {
      if (store.state.headers) {
        getUser();
      }

      getAppInfo();
      getCeremonyData();
    }); // watcher

    watch(() => worldOutlook.value, newVal => {
      if (newVal) {
        getCeremonyData();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_drawer = _resolveComponent("el-drawer");

      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [user.value && _unref(inApostleType)(user.value.user_type) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(inApostleType)(user.value.user_type) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(AccountWorkbenches)])) : _createCommentVNode("", true)])) : user.value && _unref(isUserType)(user.value.user_type) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [roleArray.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(RoleManager, {
        onOpenRoleGenerator: _cache[0] || (_cache[0] = $event => openEditMode(null))
      }), _createElementVNode("div", _hoisted_5, [_createVNode(RoleCard, {
        roleId: selectedRole.value
      }, null, 8, ["roleId"])])])) : user.value.roles_numbers > roleArray.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "empty-create-card",
        onClick: _cache[1] || (_cache[1] = $event => openEditMode(null))
      }, [_createVNode(_component_el_icon, {
        size: "16"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      }), _cache[3] || (_cache[3] = _createElementVNode("text", null, "创建一个链接雾海的角色", -1))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_el_drawer, {
        modelValue: _unref(isOpenDrawer),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(isOpenDrawer) ? isOpenDrawer.value = $event : null),
        title: "Account",
        direction: "rtl",
        size: "400",
        "with-header": false
      }, {
        default: _withCtx(() => [_createVNode(UserInfoBox, {
          onUpdateUser: getUser,
          onLogout: logout
        })]),
        _: 1
      }, 8, ["modelValue"])], 4);
    };
  }

};